"use client";

import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import { cn } from "@/lib/utils";

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    avoidCollisions={true}
    className={cn("z-50 overflow-hidden min-w-7 rounded-md bg-[#404046] px-3 py-1.5 text-xs text-[#F1F1F1]", className)}
    {...props}
  />
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

const MandoTooltip = ({
  children,
  tooltipContent,
  side = "top",
  delayDuration = 600,
}: React.PropsWithChildren<{
  tooltipContent: string;
  side?: "top" | "right" | "bottom" | "left";
  delayDuration?: number;
}>) => {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={delayDuration}>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent side={side}>
          <span>{tooltipContent}</span>
          <TooltipPrimitive.Arrow className="fill-[#404046] animate-none" />
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider, MandoTooltip };
